import { JSX } from 'react';
import { CONTENT_ICON_NAMES, contentIcon, contentIconTile } from '../../../library/contentIcons';
import { Theme } from '@mui/material';
import { getIconStyle } from './about.styles';

/**
 * The About page's binding to the shared icon set.
 *
 * The set itself lives in `library/contentIcons` now, because the front page's cards draw from
 * the same vocabulary and its editor needs the same picker. What stayed here is the only part
 * that was ever about this page: the size its card tiles draw at.
 */

/** The picker's contents, in the order it draws them. */
export const PROFILE_ICON_NAMES: string[] = CONTENT_ICON_NAMES;

/** The icon for a stored name, at the size this page's cards draw one. */
export const profileIcon = (name: string | null | undefined, theme: Theme): JSX.Element =>
    contentIcon(name, getIconStyle(theme));

/** The same icon at the size the editor's picker draws its tiles. */
export const profileIconTile = (name: string): JSX.Element => contentIconTile(name);
